module.exports = __webpack_public_path__ + "img/21_LOA_logo_JP_WH_01.832da176.png";